export const USE_CASE_COLORS = [
  '#1abc9c',
  '#3498db',
  '#f1c40f',
  '#e74c3c',
  '#F9FAFB',
] as const;

export const USE_CASE_HEADER_COLORS = USE_CASE_COLORS.filter(
  (color) => color !== '#F9FAFB'
);
